<div>

  <div class="editMode" *ngIf="editMode">
      <as-split direction="horizontal" [class.dimmer]="sliderOpen">
        <as-split-area size="40" class="as-split-area-left">
          <gen-text-viewer class="text-viewer-panel"
                           [ngClass]="curationStatus"
                           [trial]="trial">
          </gen-text-viewer>
        </as-split-area>

        <as-split-area size="60" class="as-split-area-right">
          <gen-trial-editor class="trial-editor-panel"
                            [trial]="trial"
          >
          </gen-trial-editor>
        </as-split-area>
      </as-split>

    <div [class.disable-outside-clicks]="sliderOpen">
      <div>
        <gen-panel class="node-creator-panel" [name]="panelName" [position]="panelPosition"></gen-panel>
      </div>
    </div>
  </div>

  <div class="viewMode" *ngIf="!editMode">
    <as-split direction="horizontal">
      <as-split-area size="40">
        <gen-toc-viewer class="toc-viewer-panel"
                        [trial]="trial"
                        (selectTop)="selectTop()"
                        (selectCohort)="selectCohort($event)">
        </gen-toc-viewer>
      </as-split-area>

      <as-split-area size="60">
        <gen-trial-viewer class="trial-viewer-panel"
                          [trial]="trial"
                          [curationStatus]="curationStatus">
        </gen-trial-viewer>
      </as-split-area>
    </as-split>
  </div>

</div>
